import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions/customer';

import Form from '../components/form/ui-semantic-form';
import FormElement from '../components/form/ui-semantic-form-elements';
import { Link } from '../components/router/link';

export class RegisterView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fields: {
				username: '', 
				password: ''
			},
			redirectTo: '/dashboard',
			isLoading: false,
			isSuccess: false
		};
	}
	onSuccess(response){
		this.setState({
			isSuccess: response.message
		});

		return response;
	}
	render () {
		return (
		<div id="register" className="ui middle aligned center aligned grid">
			<div className="column">
				<h2 className="ui orange label circle header">Rejestracja</h2>
				<Form 
					url="customer/register" 
					loading={this.state.isLoading} 
					action={this.props.actions.register}
					onSuccess={this.onSuccess.bind(this)} 
					buttonSubmitTitle="Zarejestruj">
						<FormElement 
							type="text" 
							name="name" 
							validations="isLength:1" 
							icon="user icon" 
							placeholder="Nazwa" 
							required
						/>
						<FormElement 
							type="text" 
							name="email" 
							validations="isLength:1,isEmail" 
							icon="mail outline icon" 
							placeholder="E-mail" 
							required
						/>
						<FormElement 
							type="text" 
							name="street" 
							validations="isLength:1" 
							icon="street view icon" 
							placeholder="Ulica" 
							required
						/>
						<FormElement 
							type="text" 
							name="post_code" 
							validations="isLength:1" 
							placeholder="Kod pocztowy" 
							required
						/>
						<FormElement 
							type="text" 
							name="city" 
							validations="isLength:1" 
							placeholder="Miasto" 
							required
						/>
						<FormElement 
							type="text" 
							name="nip" 
							validations="isLength:1" 
							placeholder="NIP" 
							required
						/>
						<FormElement 
							type="text" 
							name="phone"  
							placeholder="Telefon" 
						/>
						<FormElement 
							type="text" 
							name="contact_preson" 
							placeholder="Osoba kontaktowa"  
						/>
				</Form>
			</div>
		</div>);
	}
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
	actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterView);


/** WEBPACK FOOTER **
 ** ./js/views/RegisterView.js
 **/